import { Box, Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { AsyncActionStatus } from '../actions/common.actionTypes';
import { customSizes, spaces } from '../assets/styles/themes/tokens';
import MasterLayout from '../components/AppLayout/MasterLayout';
import EmptySearchStateImage from '../components/Search/SearchResults/EmptySearchResultsNewUI/EmptySearchStateImage';
import { routes } from '../constants';
import { getMeStatus, selectIsAuthenticated, selectUser } from '../reducers/user.selectors';
import useRouter from '../utils/useRouter';

const Error404: React.FC = () => {
	const { t } = useTranslation();
	const { router } = useRouter();
	const user = useSelector(selectUser);
	const userStatus = useSelector(getMeStatus);
	const isAuthenticated = useSelector(selectIsAuthenticated);
	const isPublic = !isAuthenticated || !user;

	if (isAuthenticated && userStatus === AsyncActionStatus.LOADING) return null;

	return (
		<MasterLayout>
			<Box
				data-testid="error-404-page"
				sx={{
					padding: spaces.xl,
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				<EmptySearchStateImage
					title={t('This page is skipping class')}
					subtitle={t("Sorry, we couldn't find this page")}
					subtitleSx={{
						maxWidth: customSizes.emptyStateSubtitleMaxWidth,
						textAlign: 'center',
					}}
					containerSx={{ paddingBottom: 0 }}
					iconName="notFound"
				/>
				<Button
					variant="outlined"
					color="primary"
					size="large"
					sx={{
						marginTop: spaces.lg,
					}}
					onClick={() => (isPublic ? router.push(`/${routes.login.root}`) : router.go(-1))}
				>
					{t('Back')}
				</Button>
			</Box>
		</MasterLayout>
	);
};

export default Error404;
